import { Size } from '../types/size'

export const sizeToWidth: Record<Size, string> = {
  s: '600px',
  m: '800px',
  xl: '100%',
  fullScreen: '100%',
}
